const styles = (theme) => {
  const isDark = theme.palette.mode === "dark";

  return {
    pageWrapper: {
      padding: "0",
      minHeight: "calc(100vh - 100px)",
    },

    // ── Control Bar ──
    controlBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "12px",
      marginBottom: "16px",
      padding: "14px 20px",
      background: isDark
        ? "linear-gradient(135deg, #1a1d23 0%, #23272f 100%)"
        : "linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)",
      borderRadius: "14px",
      border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #e5e7eb",
      boxShadow: isDark ? "none" : "0 2px 8px rgba(0,0,0,0.04)",
    },
    periodPills: {
      display: "flex",
      gap: "6px",
      flexWrap: "wrap",
    },
    pill: {
      padding: "7px 18px",
      borderRadius: "20px",
      border: isDark
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid #d1d5db",
      background: "transparent",
      color: isDark ? "rgba(255,255,255,0.55)" : "#4b5563",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 500,
      transition: "all 0.2s ease",
      "&:hover": {
        background: "rgba(59,130,246,0.12)",
        borderColor: "rgba(59,130,246,0.3)",
        color: "#3b82f6",
      },
    },
    pillActive: {
      background: "linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)",
      border: "1px solid #3b82f6",
      color: "#fff",
      "&:hover": {
        background: "linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)",
        color: "#fff",
      },
    },
    refreshBtn: {
      padding: "8px 20px",
      borderRadius: "10px",
      border: "1px solid rgba(59,130,246,0.3)",
      background: "rgba(59,130,246,0.08)",
      color: "#3b82f6",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.2s ease",
      "&:hover": {
        background: "rgba(59,130,246,0.18)",
      },
    },

    // ── Search & Filters ──
    filtersBar: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      marginBottom: "16px",
    },
    searchInput: {
      flex: "1 1 200px",
      maxWidth: "280px",
      padding: "10px 14px 10px 38px",
      borderRadius: "10px",
      border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid #d1d5db",
      background: isDark ? "rgba(255,255,255,0.03)" : "#ffffff",
      color: isDark ? "#fff" : "#1f2937",
      fontSize: "13px",
      outline: "none",
      transition: "border-color 0.2s",
      "&:focus": {
        borderColor: "rgba(59,130,246,0.4)",
      },
      "&::placeholder": {
        color: isDark ? "rgba(255,255,255,0.25)" : "#9ca3af",
      },
    },
    searchWrapper: {
      position: "relative",
      flex: "1 1 200px",
      maxWidth: "280px",
    },
    searchIcon: {
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: isDark ? "rgba(255,255,255,0.25)" : "#9ca3af",
      fontSize: "18px",
      pointerEvents: "none",
    },
    filterSelect: {
      padding: "10px 14px",
      borderRadius: "10px",
      border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid #d1d5db",
      background: isDark ? "rgba(255,255,255,0.03)" : "#ffffff",
      color: isDark ? "rgba(255,255,255,0.7)" : "#374151",
      fontSize: "13px",
      outline: "none",
      cursor: "pointer",
      minWidth: "140px",
      appearance: "none",
      backgroundImage: isDark
        ? "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='rgba(255,255,255,0.3)'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\")"
        : "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='rgba(0,0,0,0.4)'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "30px",
      "& option": {
        background: isDark ? "#1e2128" : "#ffffff",
        color: isDark ? "#fff" : "#1f2937",
      },
    },

    // ── Map Layout ──
    mapLayoutFull: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "16px",
      minHeight: "600px",
    },
    mapLayoutWithDetail: {
      display: "grid",
      gridTemplateColumns: "1fr 380px",
      gap: "16px",
      minHeight: "600px",
      "@media (max-width: 960px)": {
        gridTemplateColumns: "1fr",
      },
    },

    mapContainer: {
      position: "relative",
      borderRadius: "14px",
      overflow: "hidden",
      background: isDark ? "#0f1117" : "#e5e7eb",
      border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #d1d5db",
      minHeight: "600px",
      height: "600px",
    },
    mapCanvas: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    mapPlaceholder: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      color: isDark ? "rgba(255,255,255,0.18)" : "#9ca3af",
      fontSize: "14px",
      textAlign: "center",
      zIndex: 5,
      pointerEvents: "none",
      "& svg": { fontSize: 48, marginBottom: 8, display: "block", margin: "0 auto 8px" },
    },

    // ── Status Legend (floating top-left on map) ──
    statusLegend: {
      position: "absolute",
      top: "16px",
      left: "16px",
      background: isDark ? "rgba(18,20,26,0.92)" : "rgba(255,255,255,0.92)",
      backdropFilter: "blur(12px)",
      borderRadius: "12px",
      padding: "16px 20px",
      border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      minWidth: "180px",
      zIndex: 10,
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    },
    statusLegendTitle: {
      fontSize: "12px",
      fontWeight: 600,
      color: isDark ? "rgba(255,255,255,0.5)" : "#6b7280",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginBottom: "2px",
    },
    statusLegendRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
    },
    statusLegendLabel: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "13px",
      color: isDark ? "rgba(255,255,255,0.75)" : "#374151",
    },
    statusDot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      display: "inline-block",
    },
    statusLegendCount: {
      fontSize: "16px",
      fontWeight: 700,
      color: isDark ? "#fff" : "#111827",
    },

    // ── Nearby Branches Overlay (bottom-left on map) ──
    nearbyOverlay: {
      position: "absolute",
      bottom: "16px",
      left: "16px",
      width: "360px",
      maxWidth: "calc(100% - 32px)",
      background: isDark ? "rgba(18,20,26,0.94)" : "rgba(255,255,255,0.95)",
      backdropFilter: "blur(14px)",
      borderRadius: "14px",
      border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.1)",
      overflow: "hidden",
      zIndex: 10,
      boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
    },
    nearbyHeader: {
      padding: "14px 18px 10px",
      fontSize: "13px",
      fontWeight: 600,
      color: isDark ? "#fff" : "#111827",
      borderBottom: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #f3f4f6",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    nearbyList: {
      maxHeight: "240px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.15)",
        borderRadius: "4px",
      },
    },
    nearbyItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 18px",
      borderBottom: isDark ? "1px solid rgba(255,255,255,0.03)" : "1px solid #f9fafb",
      cursor: "pointer",
      transition: "background 0.15s ease",
      "&:hover": {
        background: isDark ? "rgba(59,130,246,0.08)" : "rgba(59,130,246,0.06)",
      },
      "&:last-child": {
        borderBottom: "none",
      },
    },
    nearbyItemActive: {
      background: isDark ? "rgba(59,130,246,0.12) !important" : "rgba(59,130,246,0.1) !important",
      borderLeft: "3px solid #3b82f6",
    },
    nearbyName: {
      fontSize: "13px",
      fontWeight: 600,
      color: isDark ? "#fff" : "#1f2937",
      marginBottom: "2px",
    },
    nearbyCoords: {
      fontSize: "11px",
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
      color: isDark ? "#60a5fa" : "#2563eb",
      marginBottom: "2px",
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },
    nearbyCoordsMissing: {
      fontSize: "11px",
      color: "#ef4444",
      marginBottom: "2px",
      fontStyle: "italic",
    },
    nearbyAddress: {
      fontSize: "11px",
      color: isDark ? "rgba(255,255,255,0.35)" : "#6b7280",
      maxWidth: "200px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    nearbyBadge: {
      padding: "3px 10px",
      borderRadius: "6px",
      fontSize: "11px",
      fontWeight: 600,
      whiteSpace: "nowrap",
    },
    badgeActive: {
      background: "rgba(59,130,246,0.12)",
      color: isDark ? "#60a5fa" : "#2563eb",
    },
    badgePartial: {
      background: "rgba(245,158,11,0.12)",
      color: isDark ? "#fbbf24" : "#d97706",
    },
    badgeInactive: {
      background: "rgba(107,114,128,0.12)",
      color: isDark ? "#9ca3af" : "#4b5563",
    },

    // ── Branch Detail Panel (right side) ──
    detailPanel: {
      position: "relative",
      background: isDark
        ? "linear-gradient(145deg, #1e2128 0%, #262a33 100%)"
        : "linear-gradient(145deg, #ffffff 0%, #f9fafb 100%)",
      borderRadius: "14px",
      border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #e5e7eb",
      padding: "24px 20px",
      overflowY: "auto",
      maxHeight: "600px",
      boxShadow: isDark ? "none" : "0 4px 12px rgba(0,0,0,0.05)",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.1)",
        borderRadius: "4px",
      },
    },
    detailClose: {
      position: "absolute",
      top: "12px",
      right: "12px",
      background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
      border: "none",
      borderRadius: "8px",
      padding: "6px",
      cursor: "pointer",
      color: isDark ? "rgba(255,255,255,0.4)" : "#6b7280",
      transition: "all 0.15s",
      zIndex: 2,
      "&:hover": {
        background: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        color: isDark ? "#fff" : "#111827",
      },
    },
    detailAvatar: {
      width: "48px",
      height: "48px",
      borderRadius: "12px",
      overflow: "hidden",
      marginBottom: "14px",
      border: isDark ? "2px solid rgba(255,255,255,0.08)" : "2px solid #e5e7eb",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    },
    detailHeader: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "6px",
      flexWrap: "wrap",
    },
    detailTitle: {
      fontSize: "18px",
      fontWeight: 700,
      color: isDark ? "#fff" : "#111827",
    },
    detailStatusBadge: {
      display: "inline-block",
      padding: "4px 12px",
      borderRadius: "8px",
      fontSize: "11px",
      fontWeight: 600,
    },
    detailSubtitle: {
      fontSize: "13px",
      color: isDark ? "rgba(255,255,255,0.4)" : "#6b7280",
      marginBottom: "18px",
      direction: "rtl",
      textAlign: "right",
    },

    // ── Detail Info Rows ──
    detailInfoSection: {
      marginBottom: "18px",
      borderTop: isDark ? "1px solid rgba(255,255,255,0.04)" : "1px solid #f3f4f6",
      paddingTop: "14px",
    },
    detailInfoRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      padding: "8px 0",
      borderBottom: isDark ? "1px solid rgba(255,255,255,0.03)" : "1px solid #f9fafb",
      "&:last-child": {
        borderBottom: "none",
      },
    },
    detailInfoLabel: {
      fontSize: "12px",
      color: isDark ? "rgba(255,255,255,0.4)" : "#6b7280",
      fontWeight: 500,
      minWidth: "100px",
      flexShrink: 0,
    },
    detailInfoValue: {
      fontSize: "13px",
      color: isDark ? "#fff" : "#1f2937",
      fontWeight: 500,
      textAlign: "right",
      wordBreak: "break-word",
    },

    // ── Detail Stats Grid ──
    detailStatsGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "10px",
      marginBottom: "18px",
    },
    detailStatItem: {
      background: isDark ? "rgba(255,255,255,0.02)" : "#f9fafb",
      borderRadius: "10px",
      padding: "12px",
      border: isDark ? "1px solid rgba(255,255,255,0.04)" : "1px solid #e5e7eb",
    },
    detailStatLabel: {
      fontSize: "10px",
      color: isDark ? "rgba(255,255,255,0.4)" : "#6b7280",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginBottom: "4px",
    },
    detailStatValue: {
      fontSize: "15px",
      fontWeight: 700,
      color: isDark ? "#fff" : "#111827",
    },

    // ── Sparkline Chart ──
    detailSparkline: {
      marginBottom: "20px",
    },
    sparkTitle: {
      fontSize: "13px",
      fontWeight: 600,
      color: isDark ? "rgba(255,255,255,0.6)" : "#4b5563",
      marginBottom: "12px",
    },
    sparkBars: {
      display: "flex",
      alignItems: "flex-end",
      gap: "6px",
      height: "80px",
    },
    sparkBarCol: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100%",
      justifyContent: "flex-end",
    },
    sparkBarValue: {
      fontSize: "9px",
      color: isDark ? "rgba(255,255,255,0.45)" : "#6b7280",
      marginBottom: "3px",
      fontWeight: 600,
    },
    sparkBar: {
      width: "100%",
      borderRadius: "4px 4px 0 0",
      minWidth: "16px",
      transition: "height 0.4s ease",
    },
    sparkLabels: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "6px",
    },
    sparkLabel: {
      fontSize: "10px",
      color: isDark ? "rgba(255,255,255,0.25)" : "#9ca3af",
      flex: 1,
      textAlign: "center",
    },

    // ── Detail Action Buttons ──
    detailActions: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      marginTop: "10px",
    },
    detailBtn: {
      padding: "11px 16px",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      border: "none",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      letterSpacing: "0.2px",
    },
    detailBtnCollected: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      color: "#fff",
      "&:hover": {
        boxShadow: "0 4px 14px rgba(16,185,129,0.35)",
        transform: "translateY(-1px)",
      },
    },
    detailBtnNotCollected: {
      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      color: "#fff",
      "&:hover": {
        boxShadow: "0 4px 14px rgba(245,158,11,0.35)",
        transform: "translateY(-1px)",
      },
    },
    detailBtnArchived: {
      background: isDark ? "rgba(255,255,255,0.08)" : "#f3f4f6",
      color: isDark ? "rgba(255,255,255,0.9)" : "#374151",
      border: isDark ? "1px solid rgba(255,255,255,0.12)" : "1px solid #d1d5db",
      "&:hover": {
        background: isDark ? "rgba(255,255,255,0.14)" : "#e5e7eb",
        transform: "translateY(-1px)",
      },
    },

    // ── Loading ──
    loadingOverlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "400px",
      color: isDark ? "rgba(255,255,255,0.4)" : "#6b7280",
      fontSize: "15px",
    },
  };
};

export default styles;
